import { setErrorDialog, serverUrl, getheader, postMethodByCallBack, getMethodByCallBack, cacheTypes, getMethod } from "../../../store/api/CommonFunctions";

export function searchStorage(name, take) {
    return dispatch => {
        dispatch({
            type: "FETCH_STORAGE_LIST",
            data: "PENDING"
        });
        fetch(serverUrl + "api/StorageAPI/SelectAllStorage?name=" + name + '&take=' + take, {
            headers: getheader(),
            method: "GET",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.message) {
                    setErrorDialog(dispatch, res.Message, "جستجوی انبار");
                    res = null;
                }
                dispatch({
                    type: "FETCH_STORAGE_LIST",
                    data: res
                });
            })
    }
}
export function searchStorage4Modal(name, take, onGetData, isStaffStorage) {
    onGetData("PENDING");
    fetch(serverUrl + `api/StorageAPI/SelectAllStorage?name=${name}&take=${take}&isStaffStorage=${isStaffStorage}`, {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.message) {
                onGetData({ Error: res.Message })
                res = null;
            }
            onGetData(res);
        }).catch(e => {
            console.log("[SEARCH_STORAGE]", e);
            onGetData({ Error: "جستجو با مشکل مواجه شد" });
        }
        )
}
export async function searchStorageAsync(name, take, isStaffStorage) {
    const result = getMethod(`api/StorageAPI/SelectAllStorage?name=${name}&take=${take}&isStaffStorage=${isStaffStorage}`);
    return result;
}
export function addEditStorage(data, onAddEdit) {
    postMethodByCallBack(`api/StorageAPI/AddEditStorage`, data, onAddEdit, "AddEditStorage");
}
export function deleteStorage(id, onDelete) {
    getMethodByCallBack(`api/StorageAPI/DeleteStorage?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteStorage");
}